import { partialRight, repeat } from 'lodash';
export const padZeros = (number, count) => number <= Number(repeat('9', count)) ? ("" + repeat('0', count) + number).slice(-count) : number;
export const padTwoZeros = partialRight(padZeros, 2);
//# sourceMappingURL=pad-zeros.js.map